import { CertNaming } from "@ndn/keychain";
/** Find certificates in KeyChain. */
export class KeyChainCertSource {
    keyChain;
    constructor(keyChain) {
        this.keyChain = keyChain;
    }
    /** Find certificates by certificate name or key name. */
    async *findCerts(keyLocator) {
        if (CertNaming.isCertName(keyLocator)) {
            try {
                const cert = await this.keyChain.getCert(keyLocator);
                yield cert;
            }
            catch { }
            return;
        }
        for (const certName of await this.keyChain.listCerts(keyLocator)) {
            if (CertNaming.toKeyName(certName).equals(keyLocator)) {
                yield await this.keyChain.getCert(certName);
            }
        }
    }
}
